module.exports = __webpack_public_path__ + "static/media/vibino-feature-Transparent-pic2.07137bf6.jpg";